import { SubscriptionOptionFragment } from "./SusbcriptionSelect-generated.hooks";
import { isAfter } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const ACTIVE_SUBSCRIPTION_STATUSES = ["pendcancel", "active", "alert"];

export function sortSubscriptionsByDate(
  a?: SubscriptionOptionFragment,
  b?: SubscriptionOptionFragment,
) {
  const dateA = a?.startDate;
  const dateB = b?.startDate;

  if (!dateA && !dateB) {
    return 0;
  }
  if (!dateA) {
    return -1;
  }
  if (!dateB) {
    return 1;
  }

  return dateB.localeCompare(dateA); // Reversed comparison
}

export const filterSubscriptions = (
  subscriptions: SubscriptionOptionFragment[],
) => {
  const currentDate = new Date(); // Get the current date

  const filteredSubscriptions = subscriptions.filter((subscription) => {
    // not show inactive
    if (!subscription.active) {
      return false;
    }

    if (!subscription.planObject.allowCheckins) {
      return false;
    }

    // not show not a active status
    if (!ACTIVE_SUBSCRIPTION_STATUSES.includes(subscription.status)) {
      return false;
    }

    // not show based on the end date
    if (subscription.endDate) {
      const endDate = utcToZonedTime(subscription.endDate, "UTC"); // Convert endDate to UTC format
      const currentUtcDate = utcToZonedTime(currentDate, "UTC"); // Convert currentDate to UTC format
      return isAfter(endDate, currentUtcDate); // Filter subscriptions with endDate after today in UTC
    }

    return true;
  });

  return filteredSubscriptions;
};
